import { useState, useEffect, useRef } from 'react'
import { isDeepEqual } from '../../lib/helpers/functionalHelpers'

/**
 * Returns a stable reference to a value that only changes when deep equality fails.
 *
 * @param props - The value to stabilize
 * @returns A stable reference
 */
export default function useStableObject<T>(props: T): T {
  const [state, setState] = useState<T>(props)
  const propsRef = useRef<T>(props)

  useEffect(() => {
    if (!isDeepEqual(props, propsRef.current)) {
      propsRef.current = props
      setState(props)
    }
  }, [props])

  return state
}
